import React from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';

/**
 * StudyFooter
 * Result feedback only — card position and navigation live in the progress dots.
 */
const StudyFooter = ({ lastResult = null }) => {
  if (!lastResult) return null;

  return (
    <div className="study-shell__footer study-shell__footer--result-only">
      <div className="study-shell__footer-result-chips">
        <span
          className={[
            'study-shell__footer-result-chip',
            'study-shell__footer-result-chip--correct',
            lastResult === 'correct' && 'study-shell__footer-result-chip--visible'
          ]
            .filter(Boolean)
            .join(' ')}
          role="status"
          aria-hidden={lastResult !== 'correct'}
        >
          <FaCheck aria-hidden="true" /> Got it
        </span>
        <span
          className={[
            'study-shell__footer-result-chip',
            'study-shell__footer-result-chip--wrong',
            lastResult === 'wrong' && 'study-shell__footer-result-chip--visible'
          ]
            .filter(Boolean)
            .join(' ')}
          role="status"
          aria-hidden={lastResult !== 'wrong'}
        >
          <FaTimes aria-hidden="true" /> Missed it
        </span>
      </div>
    </div>
  );
};

export default StudyFooter;
